import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls the window to the top
 * whenever the route/location changes.
 * This component doesn't render anything - it just performs the scroll effect.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top of the page when the route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' instead of 'smooth' for immediate scrolling without animation
    });
  }, [pathname]); // Only re-run when pathname changes

  return null; // This component doesn't render anything
};

export default ScrollToTop;